import { Route, Routes } from "react-router-dom";
import { IndexPage } from "./pages/Index";
import { OrderInvoicingProvider } from "./context/order-invoicing-state";

export function OrderInvoicingRoutes() {
	return (
		<OrderInvoicingProvider>
			<Routes>
				<Route index element={<IndexPage />} />
			</Routes>
		</OrderInvoicingProvider>
	);
}
